import { render, staticRenderFns } from "./parts.vue?vue&type=template&id=03d0f719&scoped=true&lang=pug"
import script from "./parts.vue?vue&type=script&lang=js"
export * from "./parts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d0f719",
  null
  
)

/* custom blocks */
import block0 from "./parts.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports